export default "__VITE_ASSET__Y9oCm22l__"